export default "__VITE_ASSET__DLz5LcLW__"